export interface DisabledTimeRange {
    From: string
    To: string
    Weekday: string
}

const pad2 = (value: number): string => String(value).padStart(2, '0')

const parseNumberPart = (value: string): number | null => {
    if (!/^\d+$/.test(value)) return null
    return Number(value)
}

export const normalizeTimeToApi = (raw: unknown): string | null => {
    if (typeof raw !== 'string') return null
    const source = raw.trim()
    if (source === '') return null

    const [timePart, rawMsPart] = source.split('.', 2)
    const segments = timePart.split(':').filter(Boolean)
    if (segments.length < 2) return null

    const hour = parseNumberPart(segments[0])
    const minute = parseNumberPart(segments[1])
    const second = segments.length >= 3 ? parseNumberPart(segments[2]) : 0

    if (hour == null || minute == null || second == null) return null
    if (hour < 0 || hour > 23) return null
    if (minute < 0 || minute > 59) return null
    if (second < 0 || second > 59) return null

    const msDigits = rawMsPart != null ? rawMsPart.replace(/\D/g, '') : ''
    const milliseconds = (msDigits === '' ? '000' : msDigits).padEnd(3, '0').slice(0, 3)

    return `${pad2(hour)}:${pad2(minute)}:${pad2(second)}.${milliseconds}`
}

export const toUiTime = (raw: unknown): string | null => {
    const normalized = normalizeTimeToApi(raw)
    if (normalized == null) return null
    return normalized.slice(0, 5)
}

export const normalizeDisabledTimesForApi = (ranges: unknown): DisabledTimeRange[] => {
    if (!Array.isArray(ranges)) return []
    return ranges
        .map((range: any) => {
            const from = normalizeTimeToApi(range?.From)
            const to = normalizeTimeToApi(range?.To)
            const weekday = typeof range?.Weekday === 'string' ? range.Weekday : ''
            if (from == null || to == null || weekday === '') return null
            return {
                From: from,
                To: to,
                Weekday: weekday
            }
        })
        .filter(Boolean) as DisabledTimeRange[]
}

export const mapDisabledTimesToUi = (ranges: unknown): DisabledTimeRange[] => {
    if (!Array.isArray(ranges)) return []
    return ranges
        .map((range: any) => {
            const from = toUiTime(range?.From)
            const to = toUiTime(range?.To)
            const weekday = typeof range?.Weekday === 'string' ? range.Weekday : ''
            if (from == null || to == null || weekday === '') return null
            return {
                From: from,
                To: to,
                Weekday: weekday
            }
        })
        .filter(Boolean) as DisabledTimeRange[]
}
